import React, { useState } from "react";
import axios from "axios";
import "./styles.css";
import WeatherDisplay from "./WeatherDisplay";
import DailyForecast from "./DailyForecast";

export default function Forecast(props) {
  const [WeatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);

  function weatherResponse(response) {
    setWeatherData({
      ready: true,
      coordinates: response.data.coord,
      temperature: response.data.main.temp,
      humidity: response.data.main.humidity,
      date: new Date(response.data.dt * 1000),
      description: response.data.weather[0].description,
      icon: response.data.weather[0].icon,
      wind: response.data.wind.speed,
      city: response.data.name,
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function search() {
    const apiKey = "94ad5ede50975cab44f38d9a0577cb93";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(weatherResponse);
  }

  function showCityChange(event) {
    setCity(event.target.value);
  }

  if (WeatherData.ready) {
    return (
      <div>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-9">
              <input
                type="text"
                id="searchcity"
                className="form-control"
                placeholder="Type a city"
                onChange={showCityChange}
              />
            </div>{" "}
            <div className="col-3">
              <input
                type="submit"
                className="btn btn-secondary w-100"
                value="Search"
              />
            </div>{" "}
          </div>{" "}
        </form>
        <WeatherDisplay data={WeatherData} />
        <DailyForecast coordinates={WeatherData.coordinates} />
      </div>
    );
  } else {
    search();
    return "Loading...";
  }
}
